export const environment = {
  production: false,
  apiUrl: 'https://www.dev-bazar.com',
  // apiUrl: 'https://localhost:7178',
};
